import "./App.scss";
import { HashRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import PaperWorkClearence from "./pages/Views/ProjectMagement/PaperWorkClearence";
import { ProtectedRoutes } from "./routes/ProtectedRoutes";
import { ConfirmDialog } from "primereact/confirmdialog";
import { AuthRoutes } from "routes/PublicRoutes";
import { Toast } from "primereact/toast";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <ConfirmDialog />
      <HashRouter>
        <Routes>
          <Route path="/paper" element={<PaperWorkClearence />} />
        </Routes>
        <AuthRoutes />
        <ProtectedRoutes />
      </HashRouter>
    </div>
  );
}
export default App;
